import { Spin } from 'antd';
import { SankeyChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Data {
  nodes: Array<{ name: string }>;
  links: Array<{ source: string; target: string; value: number }>;
}

function SankeyWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'sankey', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <SankeyChart nodes={data?.nodes ?? []} links={data?.links ?? []} />;
}

export const sankeyWidgetDef: WidgetDefinition = {
  type: 'sankey',
  name: 'Sankey Diagram',
  description: 'Flow between nodes',
  icon: 'DeploymentUnitOutlined',
  category: 'chart',
  defaultTitle: 'Sankey Diagram',
  defaultConfig: {},
  minW: 4, minH: 5, defaultW: 6, defaultH: 7,
  component: SankeyWidget,
  settingsSchema: { fields: [] },
};
